import { Link } from '@tanstack/react-router';
import { useState } from 'react';

import { EstadoVazio } from '@/componentes/EstadoVazio';
import { formatarDataHora } from '@/lib/formato';

/**
 * As duas telas que o roteador mostra quando a tela pedida nao existe ou
 * quebra ao abrir — no lugar do padrao do TanStack, que era "Not Found" e
 * "Something went wrong!": em ingles, com exclamacao, sem menu e sem saida.
 *
 * As duas moram DENTRO DA CASCA (a raiz desenha a barra e o menu, e o
 * roteador poe estas telas no lugar do conteudo), entao a pessoa continua
 * com o menu para ir a outro lugar. E as duas dizem o que fazer em seguida
 * (p.23; regra 10), com uma saida so, em laranja: e a unica acao da tela.
 */

/** Endereco que nao corresponde a nenhuma tela do sistema. */
export function EnderecoInexistente() {
  return (
    <div className="pagina w-full">
      <EstadoVazio
        titulo="Este endereço não existe no sistema"
        descricao="Confira o endereço digitado, ou volte ao painel e siga pelo menu."
        acao={
          <Link to="/" className="botao botao-primario">
            Ir para o painel
          </Link>
        }
      />
    </div>
  );
}

/**
 * A tela que falhou ao desenhar. O horario vai escrito porque e com ele que o
 * suporte acha o erro no registro do servidor.
 */
export function TelaQueFalhou() {
  const [quando] = useState(() => formatarDataHora(new Date()));
  return (
    <div className="pagina w-full">
      <EstadoVazio
        titulo="Esta tela falhou ao abrir"
        descricao={`Recarregue a tela. Se continuar, avise o suporte com o horário: ${quando}.`}
        acao={
          <button
            type="button"
            className="botao botao-primario"
            onClick={() => {
              window.location.reload();
            }}
          >
            Recarregar tela
          </button>
        }
      />
    </div>
  );
}
